exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fieldsListContainer {\n  padding: 16px;\n}\n\n.fieldsListContainer .fieldsListTitle {\n  font-size: 12px;\n  margin-bottom: 8px;\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.fieldsListContainer .fieldsList {\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 500px;\n}\n\n.fieldsListContainer .fieldsListErrorMessage {\n  margin: 5px;\n}\n\n.fieldsListContainer .fakeField {\n  border: 2px solid #eaeaea;\n  width: 140px;\n  height: 40px;\n  margin: 5px;\n  background-color: #eaeaea;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/components/fieldsList/fieldsList.scss
// module id = 372
// module chunks = 0